import { Avatar, Button } from "@mui/material";
import * as React from "react";
import { Link } from "react-router-dom";
import useTeam from "../hooks/useTeam";
import { ITeam, ITeamInMatch } from "../utils/api.interfaces";

interface ButtonClubProps {
  variant?: "outlined" | "contained";
  teamId?: string;
  team?: ITeam | ITeamInMatch;
}
const ButtonTeam: React.FC<ButtonClubProps> = ({
  variant = "contained",
  team,
  teamId,
}) => {
  let dataTeam = useTeam(teamId).dataTeam;

  return (
    <Button
      component={Link}
      color={"secondary"}
      to={`/teams/${teamId ? dataTeam?.id : team?.id}`}
      sx={{
        cursor: "pointer",
        fontSize: "12px",
        height: "42px",
        whiteSpace: "nowrap",
      }}
      size="small"
      startIcon={
        <Avatar
          sx={{
            backgroundColor: "#fff",
            marginRight: "6px",
            width: "35px",
            height: "35px",
          }}
          src={teamId ? dataTeam?.logoUrl : team?.logoUrl}
        ></Avatar>
      }
      // endIcon={<TeamIcon />}
      variant={variant}
    >
      {teamId ? dataTeam?.name : team?.name || "no team name"}
    </Button>
  );
};

export default ButtonTeam;
